import styled from 'styled-components';
import Button from './Button';

const TextButton = styled(Button)`
  color: ${({ theme }) => theme.color.link};
  background-color: #ffffff;

  &:disabled,
  &:disabled:hover,
  &:disabled:active {
    color: ${({ theme }) => theme.button.color.disabled};
  }
`;

export default TextButton;
